import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import BdsIconButton from '../../../../../shared/components/v3/Buttons/BdsIconButton/BdsIconButton';
import Toast from '../../../../../shared/components/v3/Toast/Toast';
import {
  BETTERFLY_SPAIN_BANK_DATA,
  COPY_BETTERFLY_SPAIN_BANK_DATA
} from '../../../../../shared/constants/flexibleRemuneration';
import { COPY_TEXT_V2_ICON } from '../../../../../shared/constants/images';
import { CLICK_ACTION, COPY_BETTERFLY_ACCOUNT_RF } from '../../../../../shared/constants/tagManager';
import { DATA_COPIED_TO_CLIPBOARD_TOAST, DEFAULT_TOAST_DATA } from '../../../../../shared/constants/toast';
import { IToast } from '../../../../../shared/interfaces/toast';
import TagManagerService from '../../../../../shared/services/gtm/tagManagerService';
import { FLEXIBLE_REMUNERATION_TRANSLATIONS } from '../../../../../shared/translations/flexibleRemuneration';

import './BankDetails.scss';

const BankDetails = () => {
  const [toast, setToast] = useState<IToast>(DEFAULT_TOAST_DATA);
  const [showToast, setShowToast] = useState<boolean>(false);
  const { t } = useTranslation();

  const onCopyText = () => {
    TagManagerService.pushEvent(CLICK_ACTION, COPY_BETTERFLY_ACCOUNT_RF);
    setToast(DATA_COPIED_TO_CLIPBOARD_TOAST);
    setShowToast(true);
    navigator.clipboard.writeText(COPY_BETTERFLY_SPAIN_BANK_DATA);
  };

  return (
    <div className="bank-details-container flex flex-row p-8" data-experience="new">
      <div className="bank-card">
        <div className="bank-item">
          <span className="label">{t(FLEXIBLE_REMUNERATION_TRANSLATIONS.transferBalance.globalHolder)}</span>
          <span className="value">{BETTERFLY_SPAIN_BANK_DATA.holder}</span>
        </div>
        <div className="bank-item">
          <span className="label">{t(FLEXIBLE_REMUNERATION_TRANSLATIONS.transferBalance.globalBank)}</span>
          <span className="value">{BETTERFLY_SPAIN_BANK_DATA.bank}</span>
        </div>
        <div className="bank-item">
          <span className="label">{t(FLEXIBLE_REMUNERATION_TRANSLATIONS.transferBalance.globalIban)}</span>
          <span className="value">{BETTERFLY_SPAIN_BANK_DATA.iban}</span>
        </div>
        <div className="bank-item">
          <span className="label">{t(FLEXIBLE_REMUNERATION_TRANSLATIONS.transferBalance.globalSwift)}</span>
          <span className="value">{BETTERFLY_SPAIN_BANK_DATA.swift}</span>
        </div>
      </div>
      <BdsIconButton icon={COPY_TEXT_V2_ICON} action={() => onCopyText()} size="sm" variant="inverse" />
      <Toast
        title={t(toast.title)}
        description={t(toast.description)}
        icon={toast.icon}
        open={showToast}
        button={true}
        handleClose={() => setShowToast(false)}
      />
    </div>
  );
};

export default BankDetails;
